/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tut_Rekam_S3Inputs */

const en_tut_rekam_s3 = /** @type {(inputs: Tut_Rekam_S3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Any participant may press **Hentikan rekaman**. The host can also end the meeting to finish it.`)
};

const id_tut_rekam_s3 = /** @type {(inputs: Tut_Rekam_S3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Siapa pun peserta boleh menekan **Hentikan rekaman**. Host juga bisa mengakhiri rapat untuk menyelesaikannya.`)
};

/**
* | output |
* | --- |
* | "Any participant may press **Hentikan rekaman**. The host can also end the meeting to finish it." |
*
* @param {Tut_Rekam_S3Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const tut_rekam_s3 = /** @type {((inputs?: Tut_Rekam_S3Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tut_Rekam_S3Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_tut_rekam_s3(inputs)
	return en_tut_rekam_s3(inputs)
});